import RemovedUsers from '$common/icons/removed-users'
import { toLocale } from '$func/text'
import { useHallRemovedSubscribersCount } from '$logic/subscription/react-hook'
import { t } from '$i18n'
import { ProfileActionItem } from '$common/profile-action-item'
import { openHallRemovedUsers } from '$logic/router'

interface Props {
  hallId: string
}

export function HallRemovedUsersProfileActionItem({ hallId }: Props) {
  const { count, loading } = useHallRemovedSubscribersCount(hallId)

  return (
    <ProfileActionItem
      Icon={<RemovedUsers />}
      onClick={() => openHallRemovedUsers(hallId)}
      secondaryText={count ? toLocale(count) : null}
      secondaryTextLoading={loading}
      iconBgColor="error500"
    >
      {t('profile.hall.actions.removedUsers')}
    </ProfileActionItem>
  )
}
